"use strict";

var _utils = require("./utils");

module.exports = function () {
    var _this = this;

    if (this.options.preload) {
        (0, _utils.queryAll)('[data-swup-preload]').forEach(function (element) {
            _this.preloadPage(element.href);
        });
    }
};